import script from "./SideFloatBar.vue?vue&type=script&setup=true&lang=js"
export * from "./SideFloatBar.vue?vue&type=script&setup=true&lang=js"

import "./SideFloatBar.vue?vue&type=style&index=0&id=669f99a4&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-669f99a4"]])

export default __exports__